import { render, staticRenderFns } from "./FaqContentItem.vue?vue&type=template&id=25662dc5&"
import script from "./FaqContentItem.vue?vue&type=script&lang=js&"
export * from "./FaqContentItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports